import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=1b0c9bc2&scoped=true"
import script from "./Instagram.vue?vue&type=script&lang=ts"
export * from "./Instagram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0c9bc2",
  null
  
)

export default component.exports